'use client';

// Client despite holding no state: the rows below hand Base UI's client `render`
// prop an element of their own, and a server element there has no type in the
// client bundle — the popup then throws React #130 on open and unmounts the
// header, in a production build only.

import {
  SearchComboboxGroup,
  SearchComboboxGroupLabel,
  SearchComboboxItem,
} from '@vs-shop/ui/searchCombobox';
import {
  SearchSuggestLink,
  SearchSuggestLinkList,
  SearchSuggestRow,
} from '@vs-shop/commerce-ui/searchPanel';

import type { SuggestHit } from '../../../effect/schema/openapi/backend';

type Props = {
  hits: SuggestHit[];
  heading: string;
  // Optional: live suggest closes the popover before navigating; the server-rendered
  // default panel omits it (native anchor navigation closes it on page change).
  onSelect?: () => void;
};

/**
 * A group of word suggestions — brands, categories, articles, popular phrases.
 *
 * The hit stops here: what crosses into `@vs-shop/commerce-ui` is a url, a
 * title and a label, on native anchor props. The combobox option around each
 * row is `@vs-shop/ui`'s, and the row paints through it.
 */
export default function SuggestLinkGroup({ hits, heading, onSelect }: Props) {
  if (hits.length === 0) return null;

  return (
    <SearchComboboxGroup>
      <SearchComboboxGroupLabel>{heading}</SearchComboboxGroupLabel>
      <SearchSuggestLinkList>
        {hits.map((hit) => (
          <SearchSuggestRow key={hit.id}>
            <SearchComboboxItem
              value={hit}
              render={
                <SearchSuggestLink href={hit.routerUrl} onClick={onSelect} title={hit.label} />
              }
            >
              {hit.label}
            </SearchComboboxItem>
          </SearchSuggestRow>
        ))}
      </SearchSuggestLinkList>
    </SearchComboboxGroup>
  );
}
